var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgShip = function SvgShip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.667 19.5c-1.159 0-2.317-.392-3.334-1.1-2.033 1.425-4.633 1.425-6.666 0-1.017.708-2.175 1.1-3.334 1.1H3.667v1.667h1.666c1.15 0 2.284-.292 3.334-.825a7.294 7.294 0 0 0 6.666 0 7.251 7.251 0 0 0 3.334.825h1.666V19.5h-1.666zM5.292 17.833h.041c1.334 0 2.517-.733 3.334-1.666.816.933 2 1.666 3.333 1.666 1.333 0 2.517-.733 3.333-1.666.817.933 2 1.666 3.334 1.666h.041l1.575-5.566a.877.877 0 0 0-.05-.65.83.83 0 0 0-.5-.417l-1.066-.35V7c0-.917-.75-1.667-1.667-1.667h-2.5v-2.5h-5v2.5H7c-.917 0-1.667.75-1.667 1.667v3.85l-1.075.35a.839.839 0 0 0-.55 1.067l1.584 5.566zM7 7h10v3.308l-5-1.641-5 1.641V7z",
    fill: "#FA5851",
    fillRule: "evenodd"
  })));
};

export default SvgShip;